import styles from "./index.module.scss";

const Header = () => {
  return (
    <header className={styles.header}>
      <div className="container">
        <h1>Автозапчасти вовремя</h1>
      </div>
    </header>
  );
};

export default Header;
